import React from 'react'

import { SliceComponent } from 'components/RichTextEditor/types'

const TagBold: SliceComponent = ({ children }) => {
  return <span className="font-semibold">{children}</span>
}
export default TagBold
